import { render, staticRenderFns } from "./Func137RecuperarSenha.vue?vue&type=template&id=55d90141&scoped=true"
import script from "./Func137RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./Func137RecuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./Func137RecuperarSenha.vue?vue&type=style&index=0&id=55d90141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d90141",
  null
  
)

export default component.exports